import {
    TextField,
} from '@mui/material';
import { formatAmount, logError } from '../Utils/FormatData';
import React, { useEffect, useRef, useState } from 'react';
import useAuthz from '../../hooks/useAuthz';
import { useAlert } from 'react-alert';
import GrilleTarifaireTable from './GrilleTarifaireTable';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import AgGrid from '../AgGrid/AgGrid';
import ActionsEditDevisRenderer from '../AgGrid/ActionsEditDevisRenderer';
import CustomNumericCellEditor from '../AgGrid/cellEditors/CustomNumericCellEditor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTableCells } from '@fortawesome/free-solid-svg-icons';
import MySelect from '../Layout/MySelect';
import { PROFIL } from '../../constants/enum';
import SapStoredRenderer from '../AgGrid/SapStoredRenderer';

const css = {
    tableHead: { border: '1px solid #4db4da', backgroundColor: '#0094ca' },
    cellHeader: {
        fontSize: '12px',
        color: 'white',
        border: '0',
        borderRight: '1px solid #ffffff4d',
        textTransform: 'uppercase',
        minWidth: '65px',
    },
    classicInput: { border: 'none', outline: 'none', width: '90%' },
    currencyInput: {
        borderTopWidth: '0px',
        borderRightWidth: '0px',
        borderLeftWidth: '0px',
        borderBottomWidth: '1px',
        outline: 'none',
        width: '90%',
        height: '29px',
    },
    textField: { width: '50%', margin: '20px' },
    rowTextField: { width: '15%', margin: '0 15px', flexGrow: 1 },
};

const FacturationTable = (props) => {
    const { dossier, grilleTarifaire, lines, setLines, firstLineAmount, totalAmount, setTotalAmount, isFacture } = props;
    const alert = useAlert();
    const [authz, user, profil] = useAuthz();
    const [newLine, setNewLine] = useState({
        quantite: 0,
        centre: '',
        libelle: '',
        tarif: 0,
        unite: '',
        description: '',
        mesures_exploit: '',
        code_comptable: ''
    });
    const [openModal, setOpenModal] = useState(false);
    const [listCenters, setListCenters] = useState([]);
    const [listAllCenters, setListAllCenters] = useState([]);
    const [selectedTarif, setSelectedTarif] = useState(null);
    const frameworkComponents = {
        'actionsEditDevisRenderer': ActionsEditDevisRenderer,
        'customNumericCellEditor': CustomNumericCellEditor,
        'sapStoredRenderer': SapStoredRenderer,
    };
    const [agGridOptions, setAgGridOptions] = useState({
        suppressCellSelection: true,
        suppressHorizontalScroll: false,
        animateRows: true,
    });
    const [tableFilters, setTableFilters] = useState({
        libelle: '',
        centre: '',
    });
    const [updateTotal, setUpdateTotal] = useState(false);
    const [gridSelectedValues, setGridSelectedValues] = useState([]);

    // region COLDEF
    const devisTableColumnAdmin = [
        {
            headerName: 'Libellé',
            field: 'libelle',
            minWidth: 150,
            sortable: true,
            editable: (params) => {
                let codeComptable = params.data.code_comptable;
                if (codeComptable && codeComptable !== '') {
                    return false;
                }
                return !dossier?.elements_factures?.status?.pdfAvailable;
            },
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Facturé',
            field: 'exist',
            flex: 1,
            width: 20,
            hide:  !isFacture,
            sortable: true,
            editable: false,
            filter: 'agTextColumnFilter',
            cellRenderer: 'sapStoredRenderer',
        },
        {
            headerName: 'Devis',
            field: 'id_devis',
            flex: 1,
            minWidth: 100,
            hide:  !isFacture,
            sortable: true,
            editable: false,
            filter: 'agNumberColumnFilter',
            type: 'rightAligned',
            cellEditor: 'customNumericCellEditor',
            cellEditorPopupPosition: 'over',
        },
        {
            headerName: 'Centre',
            field: 'centre',
            flex: 1,
            minWidth: 200,
            sortable: true,
            editable: (params) => {
                let codeComptable = params.data.code_comptable;
                if (codeComptable && codeComptable !== '') {
                    return false;
                }
                return !dossier?.elements_factures?.status?.pdfAvailable;
            },
            filter: 'agTextColumnFilter',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopupPosition: 'under',
            cellEditorParams: {
                values: [{ 'id': 0, 'label': '-' }, ...listAllCenters].map((center) => center.label),
                cellHeight: 20,
            },
        },
        {
            headerName: 'Unité',
            field: 'unite',
            flex: 1,
            minWidth: 200,
            sortable: true,
            editable: (params) => {
                let codeComptable = params.data.code_comptable;
                if (codeComptable && codeComptable !== '') {
                    return false;
                }
                return !dossier?.elements_factures?.status?.pdfAvailable;
            },
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Quantité',
            field: 'quantite',
            flex: 1,
            minWidth: 200,
            sortable: true,
            editable: !dossier?.elements_factures?.status?.pdfAvailable,
            filter: 'agNumberColumnFilter',
            type: 'rightAligned',
            cellEditor: 'customNumericCellEditor',
            cellEditorPopupPosition: 'over',
        },
        {
            headerName: 'Tarif',
            field: 'tarif',
            flex: 1,
            minWidth: 200,
            sortable: true,
            editable: (params) => {
                let codeComptable = params.data.code_comptable;
                if (codeComptable && codeComptable !== '') {
                    return false;
                }
                return !dossier?.elements_factures?.status?.pdfAvailable;
            },
            filter: 'agNumberColumnFilter',
            type: 'rightAligned',
            cellEditor: 'customNumericCellEditor',
            cellEditorPopupPosition: 'over',
        },
        {
            headerName: 'Description',
            field: 'description',
            sortable: true,
            editable: (params) => {
                let codeComptable = params.data.code_comptable;
                if (codeComptable && codeComptable !== '') {
                    return false;
                }
                return !dossier?.elements_factures?.status?.pdfAvailable;
            },
            filter: 'agTextColumnFilter',
            cellEditor: 'agLargeTextCellEditor',
            cellEditorPopupPosition: 'over',
            cellEditorPopup: true,
            cellEditorParams: {
                maxLength: 100,
                rows: 10,
                cols: 50,
            },
        },
        {
            headerName: 'Mesures d\'exploitation',
            field: 'mesures_exploit',
            sortable: true,
            editable: !dossier?.elements_factures?.status?.pdfAvailable,
            filter: 'agTextColumnFilter',
            cellEditor: 'agLargeTextCellEditor',
            cellEditorPopupPosition: 'over',
            cellEditorPopup: true,
            cellEditorParams: {
                maxLength: 100,
                rows: 10,
                cols: 50,
            },
        },
        {
            headerName: 'Total',
            field: 'total',
            flex: 1,
            minWidth: 150,
            sortable: true,
            editable: (params) => {
                let codeComptable = params.data.code_comptable;
                if (codeComptable && codeComptable !== '') {
                    return false;
                }
                return !dossier?.elements_factures?.status?.pdfAvailable;
            },
            filter: 'agNumberColumnFilter',
            cellEditorPopupPosition: 'over',
            type: 'rightAligned',
            valueGetter: (params) => {
                setUpdateTotal(true);
                return params.data.tarif ? formatAmount(Number(params.data.tarif) * Number(params.data.quantite), 2, '€') : 0;
            },
            pinned: 'right',
        },
        {
            headerName: 'actions',
            field: '',
            minWidth: 100,
            sortable: false,
            cellRenderer: 'actionsEditDevisRenderer',
            cellRendererParams: {
                onAddNewLine: (data) => handleAdd(data),
                onOpenTarificationModal: () => setOpenModal(true),
                onDeleteLine: (index) => handleDelete(index),
                disable: dossier?.elements_factures?.status?.pdfAvailable,
                isFacture: isFacture,
            },
            pinned: 'right',
        },
    ];

    const devisTableColumnCLient = [
        {
            headerName: 'Libellé',
            field: 'libelle',
            flex: 1,
            minWidth: 200,
            sortable: true,
            editable: false,
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Centre',
            field: 'centre',
            flex: 1,
            minWidth: 200,
            sortable: true,
            editable: false,
            filter: 'agTextColumnFilter',
            cellEditor: 'agRichSelectCellEditor',
        },
        {
            headerName: 'Unité',
            field: 'unite',
            flex: 1,
            minWidth: 200,
            sortable: true,
            editable: false,
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Quantité',
            field: 'quantite',
            flex: 1,
            minWidth: 200,
            sortable: true,
            editable: false,
            filter: 'agNumberColumnFilter',
            type: 'rightAligned',
        },
        {
            headerName: 'Tarif',
            field: 'tarif',
            flex: 1,
            minWidth: 200,
            sortable: true,
            editable: false,
            filter: 'agNumberColumnFilter',
            type: 'rightAligned',
        },
        {
            headerName: 'Mesures d\'exploitation',
            field: 'mesures_exploit',
            flex: 1,
            minWidth: 200,
            sortable: true,
            editable: false,
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Total',
            field: 'total',
            flex: 1,
            minWidth: 150,
            sortable: true,
            editable: false,
            filter: 'agNumberColumnFilter',
            type: 'rightAligned',
            valueGetter: (params) => {
                setUpdateTotal(true);
                return params.data.tarif ? formatAmount(Number(params.data.tarif) * Number(params.data.quantite), 2, '€') : 0;
            },
        },
    ];
    // endregion

    // region useEffect
    useEffect(() => {
        apiGetListCenters();
        apiGetAllCenters();
    }, []);

    useEffect(() => {
        if (lines) {
            updateTotalAmount();
        }
    }, [lines, firstLineAmount]);

    useEffect(() => {
        if (updateTotal) {
            updateTotalAmount();
            setUpdateTotal(false);
        }
    }, [updateTotal]);
    // endregion

    // region function
    const handleFilterChange = (e) => {
        setTableFilters({ ...tableFilters, [e.target.name]: e.target.value });
    };

    const handleAdd = (rowData) => {
        let libelle, tarifi;

        libelle = rowData.libelle;
        tarifi = rowData.newTarif;

        listAllCenters.map((center) => {
            if (center.id === rowData.centre) {
                rowData.centre = center.label;
            }
        });

        if (libelle === '' || tarifi === '') {
            alert.error('Vous devez remplir les champs libellé et tarif avant de continuer !');
        } else {
            let tabTarifs = [];
            tabTarifs.push(rowData);
            setLines([...lines, ...tabTarifs]);
            setNewLine({
                quantite: 1,
                libelle: '',
                tarif: '',
                unite: '',
                description: '',
                centre: '',
                mesures_exploit: '',
                code_comptable: '',
            });
        }
    };

    // BUG : Lorsqu'on supprime une ligne, visuellement seule la dernière est supprimée
    // WORKAROUND : Pour mettre à jour la vue correctement, on met d'abord les lignes à vide puis on met à jour les lignes
    const handleDelete = (index) => {
        if (dossier?.elements_factures?.status?.pdfAvailable === true) {
            return;
        }
        let updatedTarifs = [...lines];

        updatedTarifs.splice(index, 1);
        setLines([]);
        setTimeout(() => {
            setLines(updatedTarifs);
        }, 50);
    };

    const updateTotalAmount = () => {
        let newAmount = 0;
        let updatedLines = [...lines];

        updatedLines.map((line, i) => {
            newAmount += (Number(line.quantite) * Number(line.tarif));
        });

        let total = newAmount;

        if (firstLineAmount) {
            total = Number(newAmount) + Number(firstLineAmount);
        }

        setTotalAmount(total);
    };

    const handleGrilleTarifaireSelection = () => {
        let tabTarifs = [];

        let centerName = '';
        gridSelectedValues.map((tarif) => {
            listAllCenters.map((center) => {
                if (center.id === tarif.centre_id) {
                    centerName = center.label;
                }
            });

            tabTarifs.push({
                tarif_id: tarif.tarif_id,
                quantite: 1,
                centre: centerName,
                libelle: tarif.libelle,
                tarif: tarif.tarif,
                unite: tarif.unite,
                description: tarif.description,
                mesures_exploit: tarif.mesures_exploit,
                code_comptable: tarif.code_comptable || '',
            });
        });
        setLines([...lines, ...tabTarifs]);
        setOpenModal(false);
    };

    const handleCloseModal = () => {
        handleGrilleTarifaireSelection();
        grilleTarifaire.map((tarif) => tarif.selected = false);

        setOpenModal(false);
        setGridSelectedValues([]);
    };

    // endregion

    // region API
    // TODO: si profil === 3
    const apiGetListCenters = () => {
        axios({ method: 'get', url: `${URL_API}/localisation/centers-by-user`, params: { userId: user.user_id } })
        .then(function(response) {
            setListCenters(response.data);
        })
        .catch(function(err) {
            logError(alert, err);
        });
    };

    const apiGetAllCenters = () => {
        axios({ method: 'get', url: `${URL_API}/localisation/list-all-centers` })
        .then(function(response) {
            setListAllCenters(response.data);
        })
        .catch(function(err) {
            logError(alert, err);
        });
    };

    const onNewLineValueChange = (e, pattern) => {
        if (e.target.value === '' || new RegExp(pattern).test(e.target.value)) {
            setNewLine({ ...newLine, [e.target.name]: e.target.value });
        }
    };
    // endregion

    return (
        <>
        <div style={{ display: 'flex', flexDirection: 'column', height: '95%' }}>
            <div className='row' style={{ width: '50%' }}>
                <TextField
                    label='FILTRE LIBELLÉ'
                    type='text'
                    name='libelle'
                    value={tableFilters.libelle}
                    style={{ ...css.textField, width: 'auto', flexGrow: 1 }}
                    autoComplete='off'
                    onChange={handleFilterChange}
                />
                <TextField
                    label='FILTRE CENTRE'
                    type='text'
                    name='centre'
                    value={tableFilters.centre}
                    style={{ ...css.textField, width: 'auto', flexGrow: 1 }}
                    autoComplete='off'
                    onChange={handleFilterChange}
                />
            </div>

            <div className='row' style={{ height: '90%' }}>
                <div style={{ height: '50vh', width: '100%', borderTop: '1px solid #4db4da' }}>
                    <div style={{ height: '85%', marginBottom: '-50px' }}>
                        <AgGrid
                            gridName='ag-grid-edit-devis-table'
                            rowData={lines}
                            columnDefs={(profil.profil === 1 || profil.profil === 2 || profil.profil === 3) ? devisTableColumnAdmin : devisTableColumnCLient}
                            rowHeight={40}
                            pagination={false}
                            gridOptions={agGridOptions}
                            setGridOptions={setAgGridOptions}
                            sortable={true}
                            filters={tableFilters}
                            // pinnedBottomRowData={(profil.profil === 1 || profil.profil === 2 || profil.profil === 3) ? [newLine] : []}
                            frameworkComponents={frameworkComponents}
                        />
                    </div>
                    {!dossier?.elements_factures?.status?.pdfAvailable &&
                        <>
                            <div style={{
                                display: 'flex',
                                width: '100%',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    width: (profil.profil === 1 || profil.profil === 2 || profil.profil === 3) ? 'calc(74vw - 15px)' : 'calc(77vw - 18px)',
                                    border: '1px solid rgb(220, 225, 230)',
                                    borderTop: '0px',
                                    padding: '10px',
                                }}>
                                    <TextField
                                        label='Libellé'
                                        type='text'
                                        name='libelle'
                                        value={newLine.libelle}
                                        style={css.rowTextField}
                                        autoComplete='off'
                                        onChange={onNewLineValueChange}
                                    />
                                    <MySelect
                                        labelClass={'select-label-black'}
                                        name={'centre'}
                                        label={'CENTRE'}
                                        disableClass={true}
                                        formControlStyle={{ ...css.rowTextField, width: 'calc(13% - 5px)' }}
                                        style={{ minWidth: 'calc(6vw + 20px)', margin: '0', marginRight: '25px' }}
                                        displayLabel={true}
                                        datas={listAllCenters}
                                        value={newLine.centre}
                                        handleChange={onNewLineValueChange}
                                    />
                                    <TextField
                                        label='Unité'
                                        type='text'
                                        name='unite'
                                        value={newLine.unite}
                                        style={css.rowTextField}
                                        autoComplete='off'
                                        onChange={onNewLineValueChange}
                                    />
                                    <TextField
                                        label='Quantité'
                                        type='text'
                                        name='quantite'
                                        value={newLine.quantite}
                                        style={css.rowTextField}
                                        autoComplete='off'
                                        onChange={(e) => onNewLineValueChange(e, '^[0-9]*[.,]?[0-9]{0,2}$')}
                                    />
                                    <TextField
                                        label='Tarif'
                                        type='number'
                                        name='tarif'
                                        value={newLine.tarif}
                                        style={css.rowTextField}
                                        autoComplete='off'
                                        onChange={onNewLineValueChange}
                                    />
                                    <TextField
                                        label='Description'
                                        type='text'
                                        name='description'
                                        value={newLine.description}
                                        style={css.rowTextField}
                                        autoComplete='off'
                                        onChange={onNewLineValueChange}
                                    />
                                    <TextField
                                        label="Mesures d'exploitation"
                                        type='text'
                                        name='mesures_exploit'
                                        value={newLine.mesures_exploit}
                                        style={css.rowTextField}
                                        autoComplete='off'
                                        onChange={onNewLineValueChange}
                                    />
                                </div>
                                <div style={{
                                    display: 'flex',
                                    width: (profil.profil === 1 || profil.profil === 2 || profil.profil === 3) ? 'calc(10vw - 16px)' : 'calc(12vw - 10px)',
                                    border: '1px solid rgb(220, 225, 230)',
                                    padding: '12px',
                                    textAlign: 'end',
                                    borderLeft: '0px',
                                    borderTop: '0px',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                }}>

                                    {(profil.profil === 1 || profil.profil === 2 || profil.profil === 3) &&
                                        <div className='buttons-request-table' style={{ backgroundColor: 'transparent' }}>
                                            <FontAwesomeIcon icon={faTableCells}
                                                             style={{ color: '#0094CA', height: '18px' }}
                                                             onClick={() => setOpenModal(true)} />
                                        </div>
                                    }

                                    {(profil.profil === 1 || profil.profil === 2 || profil.profil === PROFIL.INTERVENANT) &&
                                        <div className='buttons-request-table' style={{ backgroundColor: 'transparent' }}>
                                            <FontAwesomeIcon icon={faPlus} style={{ color: '#0094CA', height: '18px' }}
                                                             onClick={() => handleAdd(newLine)} />
                                        </div>
                                    }

                                </div>
                            </div>
                        </>
                    }

                    <div style={{
                        display: 'flex',
                        width: '100%'
                    }}>
                    <div style={{
                        display: 'flex',
                        width: (profil.profil === 1 || profil.profil === 2 || profil.profil === 3) ? 'calc(74vw - 15px)' : 'calc(77vw - 18px)',
                        border: '1px solid rgb(220, 225, 230)',
                        borderTop: '0px',
                        padding: '10px',
                    }}>
                        <div style={{
                            width: '50%',
                            fontSize: '14px',
                        }}>
                            <div>Nota: Le libellé saisi sera affiché</div>
                            <div><u>sur le devis et la facture</u></div>
                        </div>
                        <div style={{
                            display: 'flex',
                            width: '50%',
                            alignItems: 'center',
                        }}>TOTAL
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        width: (profil.profil === 1 || profil.profil === 2 || profil.profil === 3) ? 'calc(10vw - 16px)' : 'calc(12vw - 10px)',
                        border: '1px solid rgb(220, 225, 230)',
                        padding: '12px',
                        textAlign: 'end',
                        borderLeft: '0px',
                        borderTop: '0px',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                    }}>
                        <b>{totalAmount && (formatAmount(totalAmount) || '0 €')}</b>
                    </div>
                </div>
            </div>
        </div>
        </div>

    <GrilleTarifaireTable
        handleCloseModal={handleCloseModal}
        openModal={openModal}
        grillesTarifaires={grilleTarifaire}
        listCenters={listCenters}
        listAllCenters={listAllCenters}
        setGridSelectedValues={setGridSelectedValues}
    />;
</>
)
    ;
};

export default FacturationTable;